import { useState, useEffect } from "react";

const useUrlInfo = () => {
  const [subdomain, setSubdomain] = useState('');
  const [domain, setDomain] = useState('');
  const currentHost = window.location.hostname;
  const rawEnvUrl = process.env.REACT_APP_URL || currentHost;
  const cleanedEnvUrl = rawEnvUrl
    .trim()
    .replace(/^['"]|['"]$/g, "")
    .replace(/^https?:\/\//, "")
    .replace(/\/.*$/, "");

  const baseDomain = cleanedEnvUrl.split(".").slice(-3).join(".");

  useEffect(() => {
    const host = window.location.host;
    const urlParts = host.split(".");

    let urlSubdomain = "";
    let urlDomain = "";

    if (urlParts.length >= 3) {
      urlDomain = urlParts.slice(-3).join(".");
      if (urlParts.length > 3) {
        urlSubdomain = urlParts.slice(0, urlParts.length - 3).join(".");
      }
    } else {
      urlDomain = host;
    }

    setSubdomain(urlSubdomain);
    setDomain(urlDomain);
  }, []);

  return { urlSubdomain: subdomain, urlDomain: domain, currentHost, rawEnvUrl, cleanedEnvUrl, baseDomain };
};

export default useUrlInfo;
